export const DIALOG_PADDING = {
  horizontal: 'px-5 sm:px-6',
  bodyVertical: 'py-6',
  headerFooterVertical: 'py-4',
};
